import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Button from 'screens/components/basic/Button';

class POSOrderSummary extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { t } = this.props; 
        const { order, stackDiscountsEnabled } = this.props;
        const orderIsCancelled = order && order.status === 'Cancelled';
        const orderIsCompleted = order && (order.status === 'Completed' || order.status === 'Returned' || order.status === 'ReturnedPartial' || order.status === 'WaitingPickUp' || order.status === 'WaitingFulfillment');
        let memberSavings = 0;
        order.products.map(x => memberSavings += (x.status == 1 || x.status == 2) ? (x.originalNonMemberPrice - x.price) : 0);
        const productTotaldiscount = order.products.reduce((acc, product) => acc + product.discountValue, 0);

        return (
            <div className="list-group-item-checkout">
                <div className="list-group-item-heading">
                    <div className="row">
                        <div className="col-lg-9 p-0">
                            <p className="pull-left pos-summary"><strong>{t('pos.orderSummary.subtotal')}</strong></p>
                        </div>
                        <div className="col-lg-3 p-0">
                            <p className="pull-right pos-summary">
                                <strong>$ {order.subTotal.toFixed(2) || "0.00"}</strong>
                            </p>
                        </div>
                    </div>
                    {
                        (this.props.stackDiscountsEnabled && order.subTotalIncludingDiscounts && order.subTotalIncludingDiscounts !== order.subTotal) &&
                        (<div className="row">
                            <div className="col-lg-9 p-0">
                                <p className="pull-left pos-summary" style={{ fontWeight: 800 }}>
                                    {t('pos.orderSummary.totalDiscounts')}
                                </p>
                            </div>
                            <div className="col-lg-3 p-0">
                                <p className="pull-right pos-summary" style={{ fontWeight: 800 }}>
                                    - $ {(order.subTotal - order.subTotalIncludingDiscounts).toFixed(2)}
                                </p>
                            </div>
                        </div>)
                    }
                    {
                        !stackDiscountsEnabled ? (
                            // Displaying order discounts or product discount when stackDiscountsEnabled is false
                            order.discounts && order.discounts.length > 0 ? (
                                order.discounts.map((discount, index) => (
                                    <div className="row" key={index}>
                                        <div className="col-lg-9 p-0">
                                            <p className="pull-left pos-summary">
                                                {discount.text}
                                                {discount.notes ? `   ( ${t('common.notes')}: ${discount.notes} )` : null}
                                            </p>
                                        </div>
                                        <div className="col-lg-3 p-0">
                                            <p className="pull-right pos-summary">
                                                - $ {discount.amount.toFixed(2) }
                                            </p>
                                        </div>
                                    </div>
                                ))
                            ) : order.subTotal !== order.subTotalIncludingDiscounts ? (
                                <div className="row">
                                    <div className="col-lg-9 p-0">
                                        <p className="pull-left pos-summary">
                                            {t('pos.orderSummary.totalProductDiscount')}
                                        </p>
                                    </div>
                                    <div className="col-lg-3 p-0">
                                        <p className="pull-right pos-summary">
                                            - $ {(order.subTotal - order.subTotalIncludingDiscounts).toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                            ) : null
                        ) : null
                    }
                    {stackDiscountsEnabled &&
                        // Displaying individual discounts when stackDiscountsEnabled is true
                        order.discounts && order.discounts.map((discount, index) => (
                            <div className="row" key={index}>
                                <div className="col-lg-9 p-0">
                                    <p className="pull-left pos-summary">
                                        {discount.text}
                                        {discount.notes ? ` ( ${t('common.notes')}: ${discount.notes} )` : null}
                                    </p>
                                </div>
                                <div className="col-lg-3 p-0">
                                    <p className="pull-right pos-summary">
                                        - $ {discount.amount.toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        ))
                    }
                    {stackDiscountsEnabled && productTotaldiscount > 0 &&
                        // Displaying total discount on products if applicable when stackDiscountsEnabled is true
                        (<div className="row">
                            <div className="col-lg-9 p-0">
                                <p className="pull-left pos-summary">
                                    {t('pos.orderSummary.totalProductDiscount')}
                                </p>
                            </div>
                            <div className="col-lg-3 p-0">
                                <p className="pull-right pos-summary">
                                    - $ {productTotaldiscount.toFixed(2)}
                                </p>
                            </div>
                        </div>)
                    }
                    {
                        order.subTotalIncludingDiscounts && order.subTotalIncludingDiscounts !== order.subTotal ? (
                            <div className="row">
                                <div className="col-lg-9 p-0">
                                    <p className="pull-left pos-summary">{t('pos.orderSummary.subtotalIncludingDiscount')} </p>
                                </div>
                                <div className="col-lg-3 p-0">
                                    <p className="pull-right pos-summary">
                                        $ {order.subTotalIncludingDiscounts.toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        order.taxesRate ? order.taxesRate.map((tax, index) => {
                            return (
                                <div className="row" key={index}>
                                    <div className="col-lg-9 p-0">
                                        <p className="pull-left pos-summary">{tax.name}</p>
                                    </div>
                                    <div className="col-lg-3 p-0">
                                        <p className="pull-right pos-summary">
                                            $ {tax.value.toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                            );
                        }) : null
                    }
                    {
                        (order && order.shippingCost > 0) && (
                            <div className="row">
                                <div className="col-lg-9 p-0">
                                    <p className="pull-left pos-summary">{t('pos.orderSummary.deliveryCost')}</p>
                                </div>
                                <div className="col-lg-3 p-0">
                                    <p className="pull-right pos-summary">
                                        $ {order.shippingCost.toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        )
                    }
                    {
                        (order && order.depositAmount > 0) && (
                            <div className="row">
                                <div className="col-lg-9 p-0">
                                    <p className="pull-left pos-summary">{t('pos.orderSummary.depositAmount')}</p>
                                </div>
                                <div className="col-lg-3 p-0">
                                    <p className="pull-right pos-summary">
                                        $ {order.depositAmount.toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        )
                    }
                    {
                         order && order.useFNTax ?
                            <p><i>{t('pos.orderSummary.FNTaxApplied')}</i></p> : null
                    }
                    {
                        order && order.taxExemptAll ?
                            <p><i>{t('pos.orderSummary.allTaxExemptionApplied')}</i></p> : null
                    }
                    {
                        (order && order.total > 0) &&
                        <div className="row mt-2">
                            <div className="col-lg-9 p-0">
                                <p className="pull-left pos-summary order_details_balance purpleText font_jakarta"><strong>{t('common.total')}</strong></p>
                            </div>
                            <div className="col-lg-3 p-0">
                                <p className="pull-right pos-summary value_nowrap order_details_balance purpleText font_jakarta">
                                    <strong>$ {order.total.toFixed(2)}</strong>
                                </p>
                            </div>
                        </div>
                    }
                    {
                        order.totalGram > 0 ? (
                            <div className="row">
                                <div className="col-lg-9 p-0">
                                    <p className="pull-left pos-summary value_nowrap grey-text purpleText font_jakarta">{t('pos.orderSummary.totalGram')} </p>
                                </div>
                                <div className="col-lg-3 p-0">
                                    <p className="pull-right pos-summary value_nowrap green-text purpleText font_jakarta">
                                        {order.totalGram.toFixed(2)}gr
                                    </p>
                                </div>
                            </div>
                        ) : null
                    }
                    {!orderIsCompleted && !orderIsCancelled ?
                        <div className="row">
                            <div className="col-lg-9 p-0">
                                <p className="pull-left pos-summary value_nowrap grey-text purpleText font_jakarta">{t('pos.orderSummary.totalProductNum')} </p>
                            </div>
                            <div className="col-lg-3 p-0">
                                <p className="pull-right pos-summary">
                                    {order.products.reduce((x, y) => {
                                        return (y.status == 1 ? x + y.quantity : x)
                                    }, 0)}
                                </p>
                            </div>
                        </div> : null}

                    {order.patient && memberSavings > 0 ?
                        <div className="row">
                            <div className="col-lg-9 p-0">
                                <p className="pull-left pos-summary value_nowrap grey-text purpleText font_jakarta">{t('pos.orderSummary.memberSavings')} </p>
                            </div>
                            <div className="col-lg-3 p-0">
                                <span className="pull-right pos-summary">
                                    ${memberSavings.toFixed(2)}
                                </span>
                            </div>
                        </div> : null}

                    {!order || order.payments.length === 0 ? null :
                        <div className="row">
                            <div className="col-lg-12 p-0">
                                <hr style={{ marginTop: "5px", marginBottom: "15px" }} />
                                <h5 className="purpleText font_jakarta">{t('pos.orderSummary.receivedPayments')}</h5>
                            </div>
                        </div>
                    }

                    {
                        order ? order.payments.map((payment, index) => {
                            return (
                                <div className="row" key={index} style={{ marginTop: "3px" }}>
                                    <div className="col-lg-10 p-0">
                                        <span className="pull-left pos-summary purpleText font_jakarta">{(payment.name === "StoreCredit") ? "Store Credit" : payment.name} </span>
                                    </div>
                                    <div className="col-lg-2 p-0" >
                                        <span className="pull-right pos-summary">
                                            $ {payment.value.toFixed(2)}
                                        </span>
                                    </div>

                                </div>
                            );
                        }) : null
                    }

                    {orderIsCancelled ?
                            <Button
                                sx={{ width: `100%`, textAlign: `center`, backgroundColor: `#ddd`, marginTop: `12px` }}
                                disabled={true}
                                variant='contained'
                            >
                                <span id="order-cancelled" style={{ margin: "18px", fontWeight: "bold", color: "#A0A0A0" }}>{t('pos.orderSummary.orderCancelled')}</span>
                            </Button>
                        : <div className="row">
                            <div className="col-lg-12 p-0">
                            <Button
                  style={{ height: 50, margin: 'auto' }}
                  className="row full-width btnNewBrandPOS mt-2 btnLarge    "
                  type="RaisedButton"
                  primary={true}
                  fullWidth
                  onTouchTap={this.props.togglePayment}
                  label={
                    !orderIsCompleted ? (
                      <div
                        id="balanceDue"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontSize: 18,
                        }}
                      >
                        <MonetizationOnIcon
                          style={{ color: 'white', width: 30, height: 30 }}
                        />
                        <span
                          style={{
                            marginLeft: '10px',
                            color: 'white',
                            fontWeight: 'bold',
                          }}
                        >
                          {t('pos.orderSummary.balanceDue')}{' '}
                          {order &&
                            order.balanceDue > 0 &&
                            '$ ' + order.balanceDue.toFixed(2)}
                        </span>
                      </div>
                    ) : (
                      <React.Fragment>
                          {t('pos.orderSummary.orderOptions')}
                      </React.Fragment>
                    )
                  }
                ></Button>
                            </div>
                        </div>}
                    {order.change > 0 ? (
                        <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-lg-10 p-0">
                                <span className="pull-left pos-summary order_details_balance green-text font_jakarta" style={{ fontSize: 20 }}><strong>{t('pos.orderSummary.change')}</strong></span>
                            </div>
                            <div className="col-lg-2 p-0">
                                <span className="pull-right pos-summary value_nowrap order_details_balance green-text font_jakarta" style={{ fontSize: 20 }}>
                                    <strong>$ {order.change.toFixed(2)}</strong>
                                </span>
                            </div>
                        </div>
                    ) : null
                    }
                    {
                        order.refund > 0 ? (
                            <div className="row">
                                <div className="col-lg-10 p-0" style={{ marginTop: "15px" }}>
                                    <span className="pull-left pos-summary font_jakarta" style={{ color: "#FF4C5B", fontSize: 20 }}><strong>{t('pos.orderSummary.refunded')}</strong></span>
                                </div>
                                <div className="col-lg-2 p-0" style={{ marginTop: "15px" }}>
                                    <span className="pull-right pos-summary value_nowrap font_jakarta" style={{ color: "#FF4C5B", fontSize: 20 }}>
                                        <strong>$ {order.refund.toFixed(2)}</strong>
                                    </span>
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        order.tipAmount > 0 ? (
                            <div className="row ">
                                <hr />
                                <div className="col-lg-10 p-0">
                                    <span className="pull-left pos-summary order_details_balance green-text"><strong>{t('pos.orderSummary.tipAmount')}</strong></span>
                                </div>
                                <div className="col-lg-2 p-0">
                                    <span className="pull-right pos-summary value_nowrap order_details_balance green-text">
                                        <strong>$ {order.tipAmount.toFixed(2)}</strong>
                                    </span>
                                </div>
                            </div>
                        ) : null
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        stackDiscountsEnabled: state.common.applicationSettings.stackDiscountsEnabled
    };
}

export default connect(mapStateToProps)(withTranslation()(POSOrderSummary))